import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { defaultSeo, seo } from '@/seo/seo';
import useSeo from '@/hooks/useSeo';

interface Props {
  children?: React.ReactNode;
}

declare global {
  interface Window {
    _mtm?: any[];
  }
}

export const PRODUCTION_DOMAIN = 'https://hivemapper.com';

export default function Page({ children }: Props) {
  const router = useRouter();
  const { title, description, keywords, image } =
    seo[router.asPath] || defaultSeo;

  useSeo({
    title,
    description,
    keywords,
    ogTitle: title,
    ogDescription: description,
    ogImage: image,
    twitterTitle: title,
    twitterDescription: description,
    twitterImage: image,
  });

  useEffect(() => {
    window._mtm = window._mtm || [];
    window._mtm.push({
      'mtm.startTime': new Date().getTime(),
      event: 'mtm.Start',
    });

    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];

    g.async = true;
    g.src =
      'https://cdn.matomo.cloud/trybeekeeperai.matomo.cloud/container_VLfonxTF.js';

    if (s?.parentNode) {
      s.parentNode.insertBefore(g, s);
    }
  }, []);

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta charSet="utf-8" />
        <meta property="og:title" content={title} />
        <meta
          property="og:url"
          content={`${PRODUCTION_DOMAIN}${router.asPath}`}
        />
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:image" content={image} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:image" content={image} />
        <meta name="twitter:description" content={description} />
        <meta
          name="twitter:url"
          content={`${PRODUCTION_DOMAIN}${router.asPath}`}
        />
        <meta property="og:site_name" content="Bee Maps" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@hivemapper" />
        <meta name="twitter:PRODUCTION_DOMAIN" content="${base}" />
        <meta
          name="facebook-PRODUCTION_DOMAIN-verification"
          content="eauxs979ttksaqj7dosv713u0rxvuz"
        />
        <link rel="shortcut icon" href="/favicon.ico" />
      </Head>
      {children}
    </>
  );
}
